// extracted by mini-css-extract-plugin
module.exports = {"image-content":"_5D1fIkae","main":"_5D2nOOTN","header":"_5D1werZl","error":"_5D2ZiI7G","information-file-reader":"_5D1qTIfH","slider":"_5D3rNsRD","avatar-container":"_5D3pMPzn"};